module.exports=function(scope){ return `<!-- enrollmentIdentifier missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "You must pass an enrollmentIdentifier parameter.",
        "subCode": "missingParameter"
    }
}

<!-- FaceMap or image missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "You must pass a valid FaceMap or image parameter.",
        "subCode": "missingParameter"
    }
}

<!-- sessionId missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "The request is missing the sessionId parameter. The sessionId parameter is required and can be obtained from the output of the FaceTec iOS/Android/Browser SDK. For more information, please visit https://dev.facetec.com/zoomsdk/#/webservice-guide.",
        "subCode": "missingParameter"
    }
}

<!-- empty enrollmentIdentifier -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Empty string not valid for parameter enrollmentIdentifier.",
        "subCode": "badStringParameter"
    }
}

<!-- empty FaceMap -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Empty string not valid for parameter FaceMap.",
        "subCode": "badStringParameter"
    }
}

<!-- empty image -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Empty string not valid for parameter image.",
        "subCode": "badStringParameter"
    }
}

<!-- Invalid sessionId -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "sessionId must be UUID in standard format.",
        "subCode": "invalidSessionId"
    }
}

<!-- enrollmentIdentifier must be up to 63 characters-->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Please provide up to 63 characters for enrollmentIdentifier.",
        "subCode": "invalidName"
    }
}

<!-- enrollmentIdentifier exists in database -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "An enrollment already exists for this enrollmentIdentifier.",
        "subCode": "nameCollision"
    }
}

<!-- FaceMap or image are less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Source data length is < 20.",
        "subCode": "unableToProcess"
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/failure/enrollment-post.json.tpl